import api from './api.js';
class Reports {
    constructor(){
        this.url_reports = 'Reports'
    }

    types(){
        return api.get(`${this.url_reports}/Orders/Types`);
    }

    generate(data){
        return api.get(`${this.url_reports}/Orders/${data.OrderId}/Types/${data.ReportTypeId}`,null,null,'blob' );
    }

    generateWithOffset(data) {
        const offsetInMinutes = new Date().getTimezoneOffset()
        const url = `${this.url_reports}/Orders/${data.OrderId}/Types/${data.ReportTypeId}/ZoneOffsetInMinutes/${offsetInMinutes}`
        return api.get(url,null,null,'blob' );
    }

    formBuilder(dto) {
        const url = `${this.url_reports}/FormBuilder`
        return api.post(url, dto, null, 'blob');
    }
}

export default new Reports
